export default __webpack_public_path__ + "static/media/case0-2.afe65856.png";